export const removePrefixFromListItems = (
    prefixToRemove: string,
    array: string[]
): typeof array => {
    const regExp = new RegExp(prefixToRemove, 'i');
    return array?.map((item) => item.replace(regExp, '')) || [];
};
